var a;!function(a){a.Small="small",a.Medium="medium",a.Large="large"}(a||(a={}));export{a as InputSize};
//# sourceMappingURL=form.js.map
